module.exports = __webpack_public_path__ + "img/icon24-opportunities-primary.564fcb3f.svg";